export default __webpack_public_path__ + "static/media/about_us_building_background.20f0e54a.png";